import { FLINT } from 'HubStyleTokens/colors';
import { ReducedCardContentBox, ReducedCardHeading } from '../../../components/ContentCards/ReducedContentCard/subcomponents/ReducedCardLayout';
import ReducedCardThumbnailSection from '../../../components/ContentCards/ReducedContentCard/subcomponents/ReducedCardThumbnailSection';
import { useTrack } from '../../tracks';
import { useLesson } from '../../lessons';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedPercentage from 'I18n/components/FormattedPercentage';
import styled from 'styled-components';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { getListingUrl } from '../../../utils/RoutingUtils';
import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import CompletedIcon from '../../../components/ContentCards/ReducedContentCard/subcomponents/CompletedIcon';
import { useShort } from '../../shortContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ItemProgressLink = styled(UIRouterLink).attrs({
  use: 'unstyled'
}).withConfig({
  displayName: "PlaylistAssignmentItemProgress__ItemProgressLink",
  componentId: "ooee3k-0"
})(["display:flex;align-items:center;"]);
const PlaylistAssignmentItemProgress = ({
  item: {
    itemId,
    language,
    type,
    name
  },
  progress,
  playlistId
}) => {
  const {
    track
  } = useTrack(itemId, language, type !== 'TRACK');
  const {
    lesson
  } = useLesson(itemId, language, type !== 'LESSON');
  const {
    short
  } = useShort(itemId, language, type !== 'SHORT_FORM_CONTENT');
  const location = useLocation();
  const {
    previewThumbnailSquareUrl
  } = track || lesson || short || {};
  const deprecated = track && track.deprecated;
  const progressAmount = progress ? progress.progressLevel : 0;
  const isCompleted = !!progress && progress.status === 'COMPLETED';
  const to = useMemo(() => {
    const {
      pathname,
      search
    } = location;
    return getListingUrl({
      type,
      id: itemId,
      language,
      appearsIn: 'playlist-assignments-monitor',
      playlistId,
      currentPathname: pathname,
      currentSearch: search
    });
  }, [itemId, language, location, playlistId, type]);
  return /*#__PURE__*/_jsxs(ItemProgressLink, {
    "data-test-id": `item_progress_${itemId}`,
    to: to,
    children: [/*#__PURE__*/_jsx(ReducedCardThumbnailSection, {
      altText: name,
      deprecated: deprecated,
      isCompleted: isCompleted,
      progressAmount: progressAmount / 100,
      size: "medium",
      thumbnailUrl: previewThumbnailSquareUrl
    }), /*#__PURE__*/_jsxs(ReducedCardContentBox, {
      children: [/*#__PURE__*/_jsx(ReducedCardHeading, {
        className: "m-bottom-0",
        size: "medium",
        style: {
          color: deprecated ? FLINT : 'inherit'
        },
        children: name
      }), isCompleted ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(CompletedIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
          "data-test-id": "percentage-label",
          message: "academyComponents.reducedContentCards.completed"
        })]
      }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
        "data-test-id": "percentage-label",
        message: "learningCenter.playlistAssignments.complete",
        options: {
          percentage: /*#__PURE__*/_jsx(FormattedPercentage, {
            value: progressAmount
          })
        }
      })]
    })]
  });
};
export default PlaylistAssignmentItemProgress;